import angular from 'angular';
import { RogersDashboardingRoutingModule } from './rogers-dashboard-routing.module';
import { RogersSlippageReportModule } from './rogers-slippage-report/rogers-slippage.module';
import { RogersRecruitingBonusReportModule } from './rogers-recruiting-bonus-report/rogers-recruiting-bonus-report.module';

import { RogersLeaderboardTableComponent } from './rogers-leaderboard-table/rogers-leaderboard-table.component';
import { RogersOnboardingSummaryComponent } from './rogers-onboarding-summary/rogers-onboarding-summary.component';
import { RogersOwnerDailyProductionReportComponent } from './rogers-owner-daily-production-report/rogers-owner-daily-production-report.component';
import { RogersOwnerDashboardContainerComponent } from './rogers-owner-dashboard/rogers-owner-dashboard-container.component';
import { RogersTrendReportComponent } from './rogers-trend-report/rogers-trend-report.component';
import { RogersTsuReportContainerComponent } from './rogers-tsu-report/rogers-tsu-report-container.component';
import { RogersTsuReportComponent } from './rogers-tsu-report/rogers-tsu-report.component';

export const RogersDashboardModule = angular
    .module("apex.mainApp.rogersDashboard", [
        RogersDashboardingRoutingModule,
        RogersSlippageReportModule,
        RogersRecruitingBonusReportModule
    ])
    .component("apexRogersLeaderBoardTable", RogersLeaderboardTableComponent)
    .component("apexRogersOnboardingSummary", RogersOnboardingSummaryComponent)
    .component("apexRogersOwnerDailyProductionReport", RogersOwnerDailyProductionReportComponent)
    .component("apexRogersOwnerDashboardContainer", RogersOwnerDashboardContainerComponent)
    .component("apexRogersTrendReport", RogersTrendReportComponent)
    .component("apexRogersTsuReportContainer", RogersTsuReportContainerComponent)
    .component("apexRogersTsuReport", RogersTsuReportComponent)
    .name;
